import { Card, Col, Row, Spin } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import { crudService, formService } from 'core/services';
import { LdapConfiguration } from 'models/LdapConfiguration';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ldapConfigurationRepository } from './LdapConfigurationRepository';
import nameof from 'ts-nameof.macro';
import { generalLanguageKeys } from 'config/consts';
import { AxiosError } from 'axios';
import { notification } from '../../helpers/notification';

export function LdapConfigurationView() {

    const [translate] = useTranslation();
    const [model, setModel] = React.useState<LdapConfiguration>(new LdapConfiguration());
    const [loading, setLoading] = React.useState<boolean>(false);
    React.useEffect(() => {
        ldapConfigurationRepository.get().then(res => setModel(res));
    }, []);

    const [
        handleChangeSimpleField,
    ] = crudService.useChangeHandlers<LdapConfiguration>(model, setModel);
    const handleSave = React.useCallback((model) => {
        setLoading(true);
        ldapConfigurationRepository.update(model).then((res: LdapConfiguration) => {
            setModel(res);
            notification.success({
                message: translate(generalLanguageKeys.update.success),
            });
        })
            .finally(() => {
                setLoading(false);
            })
            .catch((error: AxiosError<LdapConfiguration>) => {
                if (error.response && error.response.status === 400) {
                    setModel(error.response?.data);
                }
                notification.error({
                    message: translate(generalLanguageKeys.update.error),
                    description: error.message,
                });
            });
    }, [translate]);

    return (
        <Spin spinning={loading} >
            <div className="page detail-page">
                <Card
                    title={
                        <div className="d-flex justify-content-between">
                            <div className="d-flex justify-content-start">
                                {translate('ldapConfigurations.master.title')}
                            </div>
                            <div>
                                <button
                                    className="btn btn-sm btn-primary float-right"
                                    onClick={() => handleSave(model)}
                                >
                                    <i className="fa mr-2 fa-save" />
                                    {translate(generalLanguageKeys.actions.save)}
                                </button>

                            </div>
                        </div>
                    }
                    style={{ height: '89vh' }}>
                    <Row>
                        {/* <FormItem
                            validateStatus={formService.getValidationStatus<LdapConfiguration>(
                                model.errors,
                                nameof(model.errors),
                            )}
                            help={model.errors}
                        >
                        </FormItem> */}
                        <Col lg={11}>
                            <FormItem
                                validateStatus={formService.getValidationStatus<LdapConfiguration>(
                                    model.errors,
                                    nameof(model.cONNECTIONSTRING),
                                )}
                                help={model.errors?.cONNECTIONSTRING}
                            >
                                <span className="label-input">
                                    {translate('ldapConfigurations.path')}
                                </span>
                                <input
                                    type="text"
                                    defaultValue={model._CONNECTION_STRING}
                                    className="form-control form-control-sm"
                                    onChange={handleChangeSimpleField(nameof(model._CONNECTION_STRING))}
                                    placeholder={translate('ldapConfigurations.placeholder.path')}
                                />
                            </FormItem>
                            <FormItem
                                validateStatus={formService.getValidationStatus<LdapConfiguration>(
                                    model.errors,
                                    nameof(model.bASEDN),
                                )}
                                help={model.errors?.bASEDN}
                            >
                                <span className="label-input">
                                    {translate('ldapConfigurations.baseDomain')}
                                </span>
                                <input
                                    type="text"
                                    defaultValue={model._BASE_DN}
                                    className="form-control form-control-sm"
                                    onChange={handleChangeSimpleField(nameof(model._BASE_DN))}
                                    placeholder={translate('ldapConfigurations.placeholder.baseDomain')}
                                />
                            </FormItem>
                            <FormItem
                                validateStatus={formService.getValidationStatus<LdapConfiguration>(
                                    model.errors,
                                    nameof(model.aDMINUSERNAME),
                                )}
                                help={model.errors?.aDMINUSERNAME}
                            >
                                <span className="label-input">
                                    {translate('ldapConfigurations.username')}
                                </span>
                                <input
                                    type="text"
                                    defaultValue={model._ADMIN_USERNAME}
                                    className="form-control form-control-sm"
                                    onChange={handleChangeSimpleField(nameof(model._ADMIN_USERNAME))}
                                    placeholder={translate('ldapConfigurations.placeholder.username')}
                                />
                            </FormItem>
                            <FormItem
                                validateStatus={formService.getValidationStatus<LdapConfiguration>(
                                    model.errors,
                                    nameof(model.aDMINPASSWORD),
                                )}
                                help={model.errors?.aDMINPASSWORD}
                            >
                                <span className="label-input">
                                    {translate('ldapConfigurations.password')}
                                </span>
                                <input
                                    type="text"
                                    defaultValue={model._ADMIN_PASSWORD}
                                    className="form-control form-control-sm"
                                    onChange={handleChangeSimpleField(nameof(model._ADMIN_PASSWORD))}
                                    placeholder={translate('ldapConfigurations.placeholder.password')}
                                />
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
            </div>
        </Spin>

    );
}